/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  GetRpcRucStatusForFleet200Item,
  GetRpcRucStatusForFleetParams,
  PostRpcRucStatusForFleet200Item,
  PostgrestError,
  RpcRucStatusForFleetArgs
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getRpcRucStatusForFleetResponse200 = {
  data: GetRpcRucStatusForFleet200Item[]
  status: 200
}

export type getRpcRucStatusForFleetResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getRpcRucStatusForFleetResponseSuccess = (getRpcRucStatusForFleetResponse200) & {
  headers: Headers;
};
export type getRpcRucStatusForFleetResponseError = (getRpcRucStatusForFleetResponseDefault) & {
  headers: Headers;
};

export type getRpcRucStatusForFleetResponse = (getRpcRucStatusForFleetResponseSuccess | getRpcRucStatusForFleetResponseError)

export const getGetRpcRucStatusForFleetUrl = (params: GetRpcRucStatusForFleetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/rpc/ruc_status_for_fleet?${stringifiedParams}` : `${backendBaseUrl}/rpc/ruc_status_for_fleet`
}

/**
 * @summary Call `ruc_status_for_fleet()`.
 */
export const getRpcRucStatusForFleet = async (params: GetRpcRucStatusForFleetParams, options?: RequestInit): Promise<getRpcRucStatusForFleetResponse> => {

  const res = await fetch(getGetRpcRucStatusForFleetUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getRpcRucStatusForFleetResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getRpcRucStatusForFleetResponse
}


export type postRpcRucStatusForFleetResponse200 = {
  data: PostRpcRucStatusForFleet200Item[]
  status: 200
}

export type postRpcRucStatusForFleetResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type postRpcRucStatusForFleetResponseSuccess = (postRpcRucStatusForFleetResponse200) & {
  headers: Headers;
};
export type postRpcRucStatusForFleetResponseError = (postRpcRucStatusForFleetResponseDefault) & {
  headers: Headers;
};

export type postRpcRucStatusForFleetResponse = (postRpcRucStatusForFleetResponseSuccess | postRpcRucStatusForFleetResponseError)

export const getPostRpcRucStatusForFleetUrl = () => {




  return `${backendBaseUrl}/rpc/ruc_status_for_fleet`
}

/**
 * @summary Call `ruc_status_for_fleet()`.
 */
export const postRpcRucStatusForFleet = async (rpcRucStatusForFleetArgs: RpcRucStatusForFleetArgs, options?: RequestInit): Promise<postRpcRucStatusForFleetResponse> => {

  const res = await fetch(getPostRpcRucStatusForFleetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(rpcRucStatusForFleetArgs)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postRpcRucStatusForFleetResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postRpcRucStatusForFleetResponse
}


